import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/**
 * React.createPortal的简单封装。
 * @type 其他
 * @name 自定义挂载
 */
export default function Portal(props) {
  var _useState = useState(),
      container = _useState[0],
      setContainer = _useState[1];

  var children = props.children,
      getContainer = props.getContainer;
  useEffect(function () {
    setContainer(getContainer ? getContainer() : document.body);
  }, [getContainer]);
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
}